import * as encoding from 'encoding';

export function byteLength (str, byWhom:'apistore'|'twilio' = 'apistore'):number {
  str = String(str);
  str = stripTags(str);
  if (byWhom === 'twilio') {
    if (isGSMAlphabet(str)) {
      return Math.ceil(str.length * (7/8));
    }
    else {
      return str.length * 2;
    }
  }
  else {
    return encoding.convert(str, 'EUC-KR').byteLength;
  };
}


export function stripTags(html):string {
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}    

export function isGSMAlphabet(text) {
  var regexp = new RegExp("^[A-Za-z0-9 \\r\\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!\"#$%&'()*+,\\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\\\\[~\\]|\u20AC]*$");
  return regexp.test(text);
}